import React from "react";
import styles from "./Header.Consulting.module.scss";
import { useNavigate } from "react-router-dom";
import { MdArrowBackIosNew } from "react-icons/md";
import { RiLayoutGridFill } from "react-icons/ri";

function HeaderConsulting({ title }) {
  const navigate = useNavigate();

  return (
    <div className={styles.header}>
      <div className={styles.headerBack} onClick={() => navigate(-1)}>
        <MdArrowBackIosNew />
      </div>

      <div className={styles.headerTitle}>
        <span>{title}</span>
      </div>

      <div
        onClick={() => navigate("/profile")}
        className={styles.headerProfile}
      >
        <RiLayoutGridFill />
      </div>
    </div>
  );
}

export default HeaderConsulting;